import { createCommonApiResponseSchema } from "@/server/agentTypes";
import { z } from "zod";

export const GetConsiderationStatusResponseSchema =
  createCommonApiResponseSchema(
    z.object({
      redirectType: z.number(),
      timeLeft: z.number(),
      considerationStatus: z.number(),
    })
  );

export const SendToConsiderationResponseSchema = createCommonApiResponseSchema(
  z.object({
    redirectType: z.union([
      z.literal(0),
      z.literal(1),
      z.literal(2),
      z.literal(3),
    ]),
    timeLeft: z.number(),
  })
);

export const TranshInfoResponseSchema = createCommonApiResponseSchema(
  z.object({
    data: z.object({
      isTransh: z.boolean(),
      transhNumber: z.number(),
      isFirstTransh: z.boolean(),
      text: z.string().optional(),
      link: z.string().optional(),
    }),
  })
);
